import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=645b5378&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=645b5378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b5378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645b5378')) {
      api.createRecord('645b5378', component.options)
    } else {
      api.reload('645b5378', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=645b5378&scoped=true&", function () {
      api.rerender('645b5378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sDLVHJ3qLb8p/JS/comp/SearchFilterTokens.vue"
export default component.exports